module.exports = __webpack_public_path__ + "img/mfd_strategy.07247be4.png";